import { render, staticRenderFns } from "./PaidTransaction.vue?vue&type=template&id=6fd9b12f&scoped=true&"
import script from "./PaidTransaction.vue?vue&type=script&lang=js&"
export * from "./PaidTransaction.vue?vue&type=script&lang=js&"
import style0 from "./PaidTransaction.vue?vue&type=style&index=0&id=6fd9b12f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9b12f",
  null
  
)

export default component.exports